import { Avatar, Space, Tag, Tooltip, Typography } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { Venue as VenueModel } from '../../models/Venue'
import { Link } from 'react-router-dom'

const { Text } = Typography

interface Props {
  model?: VenueModel
}

export const VenueAddress = ({ model }: Props) => {
  const venue = model

  if (!venue) {
    return <></>
  }

  return (
    <Text type="secondary" style={{ fontSize: 12 }}>
      {venue.address?.label} {venue.address?.postCode}
    </Text>
  )
}

export type VenueAddressType = { Address: typeof VenueAddress }
